import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/AlertDialog';
import { useStudents } from '../../contexts/StudentsContext';
import type { Student } from '../../types/student';
import { describeSupabaseError } from '../../utils/supabase';
interface DeleteStudentDialogProps {
  student: Student | null;
  onClose: () => void;
}
export function DeleteStudentDialog({
  student,
  onClose
}: DeleteStudentDialogProps) {
  const {
    removeStudent
  } = useStudents();
  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    if (!student) return;
    setDeleting(true);
    try {
      await removeStudent(student);
      toast.success('Record deleted from Supabase', {
        description: student.fullNames.trim() || 'Untitled record'
      });
      onClose();
    } catch (error) {
      toast.error('Could not delete the record', {
        description: describeSupabaseError(error)
      });
    } finally {
      setDeleting(false);
    }
  };
  return <AlertDialog open={Boolean(student)} onOpenChange={open => open ? undefined : onClose()} data-id="element-245" data-mp="3f5plyepjbpap">
      <AlertDialogContent className="glass-strong rounded-3xl" data-id="element-246" data-mp="3a74q0rhbfrs2">
        <AlertDialogHeader data-id="element-247" data-mp="3a8z2dheiubkj">
          <AlertDialogTitle data-id="element-248" data-mp="357jjnvztgh5b">Delete this student record?</AlertDialogTitle>
          <AlertDialogDescription data-id="element-249" data-mp="359mhv3b4hgl4">
            {student?.fullNames.trim() || 'This record'} will be permanently removed from the Supabase students table.
            This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter data-id="element-250" data-mp="2rhg2hjfsndmq">
          <AlertDialogCancel disabled={deleting} className="rounded-xl" data-id="element-251" data-mp="2ri7z8xl4nhel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={event => {
          event.preventDefault();
          void handleDelete();
        }} disabled={deleting} className="rounded-xl bg-destructive text-white hover:opacity-90" data-id="element-252" data-mp="2mj4qp35xut1v">
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-253" data-mp="2crld40539ujk" />}
            {deleting ? 'Deleting…' : 'Delete record'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}